import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowTrendUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.04375 6.86563C2.19375 7.01563 2.375 7.08763 2.5875 7.08163C2.8 7.07513 2.98125 6.99688 3.13125 6.84688L5.25 4.72813L5.25 13.0906C5.25 13.3031 5.322 13.4814 5.466 13.6254C5.6095 13.7689 5.7875 13.8406 6 13.8406C6.2125 13.8406 6.39075 13.7689 6.53475 13.6254C6.67825 13.4814 6.75 13.3031 6.75 13.0906L6.75 4.72813L8.8875 6.86562C9.0375 7.01562 9.21575 7.09062 9.42225 7.09062C9.62825 7.09062 9.80625 7.01562 9.95625 6.86562C10.1063 6.71562 10.1813 6.53738 10.1813 6.33088C10.1813 6.12488 10.1063 5.94687 9.95625 5.79687L6.525 2.36563C6.45 2.29063 6.36875 2.23737 6.28125 2.20587C6.19375 2.17487 6.1 2.15937 6 2.15937C5.9 2.15937 5.80625 2.17487 5.71875 2.20587C5.63125 2.23737 5.55 2.29063 5.475 2.36563L2.025 5.81563C1.8875 5.95313 1.81875 6.12488 1.81875 6.33088C1.81875 6.53738 1.89375 6.71563 2.04375 6.86563Z",
		fill: "black"
	})
});
export default SvgArrowTrendUp;
